import { Button } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useEntitlement } from '../domain-engine/useEntitlement';

const DEFAULT_TENANT_ID = '01HXYZ000000000000000001';

interface WizardListToolbarProps {
  domainId: string;
  wizardPath: string;
  label?: string;
}

export function WizardListToolbar({ domainId, wizardPath, label }: WizardListToolbarProps) {
  const { hasEntitlement, isLoading } = useEntitlement(DEFAULT_TENANT_ID);
  const navigate = useNavigate();

  if (isLoading) return null;
  if (!hasEntitlement(domainId)) return null;

  return (
    <Button
      variant="contained"
      startIcon={<AutoAwesome />}
      onClick={() => navigate(`/${wizardPath}`)}
      sx={{ mb: 2 }}
    >
      {label ?? 'New via Wizard'}
    </Button>
  );
}
